import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '@/lib/api';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');
    if (!sessionId) { navigate('/'); return; }

    api.post('/auth/session', { session_id: sessionId, referral_code: sessionStorage.getItem('bisne_ref') || '' })
      .then((res) => {
        const nextUrl = sessionStorage.getItem('bisne_next') || '/';
        sessionStorage.removeItem('bisne_next');
        sessionStorage.removeItem('bisne_ref');
        navigate(nextUrl, { state: { user: res.data }, replace: true });
      })
      .catch(() => navigate('/'));
  }, [navigate, location]);

  return (
    <div data-testid="auth-callback" className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center space-y-4">
        <h2 className="font-heading text-4xl text-primary">BISNE</h2>
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="text-muted-foreground font-body text-sm">Iniciando sesion...</p>
      </div>
    </div>
  );
}
